
        function addEventListenerStamped(el, eventName, handler) { 
          if (el.addEventListener) { el.addEventListener(eventName, handler); }
          else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
        }
  
        $(document).ready(function(){
          // Example
      


          var pagi_review_click_count = 0;

          // Listening for reviews widget loaded event
          addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {  
            // Handler for .load() called.

                   // $( window ).on("load", function() {
                          setTimeout(function(){ 
                  
                            $(".stamped-wall-photos-wrapper> div").each(function(){
                                if ($(this).is(':empty')){
                                  $(this).remove();
                                }       
                              	$(this).find(".stamped-reviews-holder").prepend(`<div class="review_block_top_info"></div> <div class="review_block_bottom_info"></div>`);
                              	var destination_top_block = $(this).find(".stamped-reviews-holder .review_block_top_info");
                              	var destination_bottom_block = $(this).find(".stamped-reviews-holder .review_block_bottom_info");
                              	//var get_main_info_block_ratting = $(this).find(".stamped-reviews-holder");
                              	//var get_main_info_block_ratting = $(this).find(".stamped-reviews-holder");                              
                              	$(this).find(".stamped-reviews-holder .stamped-reviews-rating").appendTo(destination_top_block);
                              	$(this).find(".stamped-reviews-holder .stamped-reviews-message").appendTo(destination_top_block);
                              
                              	$(this).find(".stamped-reviews-holder .stamped-reviews-author").appendTo(destination_bottom_block);
                              	$(this).find(".stamped-reviews-holder .stamped-reviews-location").appendTo(destination_bottom_block);
                              	$(this).find(".stamped-reviews-holder .stamped-reviews-title").appendTo(destination_bottom_block);
                                $(this).find(".stamped-reviews-holder .stamped-reviews-vote").appendTo(destination_bottom_block);
                                $(this).find(".stamped-reviews-holder .stamped-reviews-image-wrapper").appendTo(destination_bottom_block);
                              
                            });
                            
                            var get_cut_reviews = $(".stamped-wall-photos-wrapper").html();
                            let get_cut_reviews_result = get_cut_reviews.replace("data-src", "src");
                            let get_total_reviews_count = $(".product_reviews_panel .stamped-summary-text").attr("data-count");
                            
                            let get_section_reviews_title = $(".custom_slider_stamped_reviews_widget").attr("data-cp-title");
                            let get_section_reviews_subtitle = $(".custom_slider_stamped_reviews_widget").attr("data-cp-subtitle");
                            
                            
                            
                            
                            var get_cut_reviews_slide = $(".stamped-summary-photos.stamped-summary-photos-container .stamped-photos-carousel div:first-child").html();
                            $('<div class="cp_stamped-summary-photos_section"  id="cp_stamped-summary-photos_section_stop"><div class="shell"><div class="stamped-photos-title"><h2>'+ get_section_reviews_title +'</h2> <span class="title_sold_msg">'+ get_section_reviews_subtitle +'</span></div><div class="cp_stamped-photos-carousel owl-carousel" id="outuer_stamped-wall-photos-wrapper">'+get_cut_reviews_result+'</div><div class="bottom_button_block"><a href="/pages/hottap-v2-reviews?back=hottap_v3_modal_windows_v3&section=cp_stamped-summary-photos_section_stop" class="btn btn--inverse">See all '+get_total_reviews_count+' reviews</a></div></div></div>').insertBefore(".stamped-wall-photos-wrapper");
                            $(".stamped-wall-photos-wrapper").addClass("hide");

                            jQuery('#outuer_stamped-wall-photos-wrapper').owlCarousel({
                              loop: true,
                              margin: 20,
                              nav: true,
                              touchDrag:true,
                              items: 3,
                              navText: [
                                '<i class="arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></i>',
                                '<i class="arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></i>'
                              ],
                              autoplay: false,
                              mouseDrag: true,
                              responsiveClass: true,
                              responsive: {
                                0:{
                                  items: 1,
                                  margin: 10
                                },
                                479:{
                                  items: 1,
                                  margin: 10
                                },
                                650:{
                                  items: 2
                                },
                                800:{
                                  items: 2,
                                  margin: 20
                                },
                                924:{
                                  items: 2,
                                  margin: 20
                                },
                                1080:{
                                  items: 3,
                                  margin: 20
                                },
                                1280:{
                                  items: 3
                                }
                              }
                            });

                            $(".cp_stamped-summary-photos_section .cp_stamped-photos-carousel .owl-item").each(function() {
                                var text = $(this).html();
                                text = text.replace("data-src", "src");
                                $(this).html(text);
                            });

                          }, 3000);                            
                    //});
            
        		$(document).ready(function(){
                  
                  //alert("dgg");
                             
                  
                  if($(".stamped-wall-photos-wrapper").length){
                    	//alert("okd");
                  }
                  
              $(".stamped-reviews .stamped-review").each(function(){
                //alert($(this).text());
                var get_cut_auther = $(this).find(".stamped-review-header .author").html();
                var get_cut_r_date = $(this).find(".stamped-review-header .created").html();
                 $(this).find(".stamped-review-content").append('<div class="stamped-review-content-footer"><strong class="created">'+get_cut_auther+'</strong><div class="author">'+get_cut_r_date+'</div></div>');
              });
        		  var previous_p_arrow_var = '<li class="previous custom_re_previous"><a href="#" data-page="1" onclick="StampedFn.pageReviews(\'1\', \'\', this); return false;" role="button" aria-label="Previous page" tabindex="0"><</a></li>';          
              var next_p_arrow_var = '<li class="next custom_re_next"><a href="#" data-page="2" onclick="StampedFn.pageReviews(\'2\', \'\', this); return false;" role="button" aria-label="Next page" tabindex="0">></a></li>';          
          
              // Start : stamped-pagination on click                   
              $('body').on('click', '.stamped-pagination li', function() {

                pagi_review_click_count = 1;

                var get_pag_curr_no = $(this).find("a").attr("data-page");
                //alert(get_pag_curr_no);
                
                if(pagi_review_click_count <= 0){
                  if(get_pag_curr_no == '1'){ 
                    setTimeout(function(){ 
                      if($(".stamped-pagination").find("li").hasClass(".previous")){
                      }else{
                        $(previous_p_arrow_var).prependTo('.stamped-pagination'); 
                      }
                    }, 2000);
                  }

                  setTimeout(function(){ 
                    $(".stamped-reviews .stamped-review").each(function(){
                      var get_cut_auther = $(this).find(".stamped-review-header .author").html();
                      var get_cut_r_date = $(this).find(".stamped-review-header .created").html();
                      $(this).find(".stamped-review-content").append('<div class="stamped-review-content-footer"><strong class="created">'+get_cut_auther+'</strong><div class="author">'+get_cut_r_date+'</div></div>');
                    });
                  }, 2500);
                }

                $('html, body').animate({
                    scrollTop: $("#stamped-summary-photos_section_stop").offset().top + 90
                }, 2000);
              });

              // End : stamped-pagination on click
              if(pagi_review_click_count <= 0){
                setTimeout(function(){                   
                  var get_cut_reviews = $(".stamped-summary-photos.stamped-summary-photos-container").html();
                  var get_cut_reviews_slide = $(".stamped-summary-photos.stamped-summary-photos-container .stamped-photos-carousel div:first-child").html();
                  $('<div class="stamped-summary-photos_section"  id="stamped-summary-photos_section_stop"><div class="stamped-photos-title"> Customer Photos </div><div class="stamped-photos-carousel owl-carousel" id="reveiws_stamped">'+get_cut_reviews_slide+'</div></div>').insertBefore(".stamped-reviews");

                  jQuery('#reveiws_stamped').owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    touchDrag:true,
                    items: 7,
                    navText: [
                      '<i class="arrow-left"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 2L3 8.66667L9 15.3333" stroke="#332D2F" stroke-width="3"/></svg></i>',
                      '<i class="arrow-right"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 15L8 8.33333L2 1.66667" stroke="#332D2F" stroke-width="3"/></svg></i>'
                    ],
                    autoplay: false,
                    mouseDrag: true,
                    responsiveClass: true,
                    responsive: {
                      0:{
                        items: 4
                      },
                      479:{
                        items: 4
                      },
                      650:{
                        items: 4
                      },
                      800:{
                        items: 5
                      },
                      924:{
                        items: 7
                      },
                      1080:{
                        items: 8
                      },
                      1280:{
                        items: 9
                      }
                    }
                  });
                }, 1000);
              }
            });
          });
          
          function moveAvatar(){	
            $('.stamped-ugc-modal-content').each(function(){	
              $('.stamped-ugc-modal-date', this).insertAfter($('.stamped-ugc-modal-user-username', this));
            });

            $( ".stamped-ugc-modal-image-wrapper" ).wrap( "<div class='rev_popup_first_block'></div>" );
            $(".stamped-ugc-modal-content").appendTo(".rev_popup_first_block");
            //$(".stamped-ugc-modal-nav-previous").prependTo(".rev_popup_first_block .stamped-ugc-modal-image-wrapper");
            //$(".stamped-ugc-modal-nav-next").appendTo(".rev_popup_first_block .stamped-ugc-modal-image-wrapper");
            $('.stamped-ugc-modal-wrapper').append('<div class="stamped-modal-close">x</div>');
            
           var windowSize = $(window).width();

            if (windowSize <= 450) {            

                  $('.rev_popup_first_block').each(function(){	              

                      $('.stamped-ugc-modal-image-wrapper').prepend('<div class="stamped-modal-top-header-section"><div class="stamped-inner-top-rating"></div><div class="stamped-inner-top-title"></div></div>');              
                      $('.stamped-ugc-modal-caption-rating', this).appendTo($('.stamped-modal-top-header-section .stamped-inner-top-rating', this));
                      $('.stamped-ugc-modal-caption-title', this).appendTo($('.stamped-modal-top-header-section .stamped-inner-top-title', this));
                      //$('.stamped-ugc-modal-caption-title', this).appendTo($('.stamped-modal-top-header-section', this));

                      $('<div class="stamped-modal-bottom-footer-section"><div class="stamped-inner-bottom-tags"></div></div>').insertAfter('.rev_popup_first_block');
                      $('.stamped-ugc-modal-tags', this).appendTo($('.stamped-modal-bottom-footer-section .stamped-inner-bottom-tags'));

                  });             
            }
                            
            
          }	
          addEventListenerStamped(document, 'stamped:ugcmodal:open', function(e) {
            moveAvatar();
          });
          
          addEventListenerStamped(document, 'stamped:ugcmodal:paged', function(e) {
      
                  $('.rev_popup_first_block').each(function(){	              

                      var get_rev_date_attr = $('.stamped-ugc-modal-caption .stamped-ugc-modal-date', this).attr("data-date");
                      var get_rev_date_value = $('.stamped-ugc-modal-caption .stamped-ugc-modal-date', this).text();
                    
                      $('.stamped-ugc-modal-user .stamped-ugc-modal-date', this).attr("data-date",get_rev_date_attr);
                      $('.stamped-ugc-modal-user .stamped-ugc-modal-date', this).text(get_rev_date_value);
                  });             
            
                var windowSize = $(window).width();

                if (windowSize <= 450) {  

                    $('.rev_popup_first_block').each(function(){	              

                        $('.stamped-modal-top-header-section .stamped-inner-top-rating', this).html($('.stamped-ugc-modal-content .stamped-ugc-modal-caption-rating', this));
                        $('.stamped-modal-top-header-section .stamped-inner-top-title', this).html($('.stamped-ugc-modal-content .stamped-ugc-modal-caption-title', this));              
                        $('.stamped-modal-bottom-footer-section .stamped-inner-bottom-tags', this).html($('.stamped-ugc-modal-content .stamped-ugc-modal-tags', this));                              
                    });            

                }            
            
          });            
          
          //moveAvatar();

        });
